import { render, staticRenderFns } from "./CopyStudentForm.vue?vue&type=template&id=034b434a"
import script from "./CopyStudentForm.vue?vue&type=script&lang=js"
export * from "./CopyStudentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports